// Grid.js
import React from 'react';
import { motion } from 'framer-motion';
import GridSlider from './Slider/GridSlider';
import { Link } from 'react-router-dom';

const Grid = ({ data }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      className="container mx-auto p-4 grid gap-8 grid-cols-1"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {data.map((item, index) => (
        <motion.div
          key={index}
          className={`flex flex-col mb-3 md:flex-row gap-4 ${index % 2 === 1 ? 'md:flex-row-reverse' : ''} items-start justify-start md:items-stretch`}
          variants={itemVariants}
        >
          {/* Slider for images */}
          <motion.div
            className="w-full md:w-1/2 md:h-96 overflow-hidden rounded"
            initial={{ opacity: 0, x: -100 }} // Image specific animation
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }} // Delay for staggered effect
            viewport={{ once: true }}
            whileHover={{ scale: 1.05 }} // Add hover effect
          >
            <GridSlider images={[item.bgImg1, item.bgImg2]} />
          </motion.div>

          {/* Static text content */}
          <div className="w-full md:w-1/2 flex flex-col justify-between md:mt-0 md:px-4 text-textColor-100">
            <div>
              <motion.h3
                className="text-2xl md:text-3xl font-thin tracking-wider mb-3 subpixel-antialiased"
                variants={itemVariants}
              >
                {item.header1}
              </motion.h3>
              <motion.p className="text-base" variants={itemVariants}>
                {item.bodyText}
              </motion.p>
            </div>
            <Link to='/products'>
            <motion.button
              className="text-sm font-medium text-start text-yellow-600 capitalize mt-4"
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              
            >
              {item.btnText}
            </motion.button>
            </Link>

          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default Grid;
